import * as React from "react";
import * as Markdown from 'react-markdown';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

export const ExistingDataConflict = ({ configurationWarning }) => {
    const tooltip = <Tooltip id="tooltip" style={{ zIndex: 2500 }}>
        <Markdown>{configurationWarning}</Markdown>
    </Tooltip>

    return (
        <OverlayTrigger placement="top" overlay={tooltip}>
            <FontAwesomeIcon className="text-warning" icon={faTriangleExclamation} />
        </OverlayTrigger>
    );
}
